<template>
  <div id="app">
    <!-- <perfect-scrollbar ref="pScroll"> -->
    <vue-headful :title="options.pageTitleText" />
    <router-view v-if="options.defaultAirport" name="header" />
    <div v-if="options.defaultAirport" class="page">
      <router-view />
      <n-button
        v-if="showReserve"
        type="success"
        class="btn-reserve"
        @click.native="$router.push('/offers')"
      >
        Reserve Now
      </n-button>
    </div>
    <router-view v-if="options.defaultAirport" name="footer" />

    <LoginModal ref="loginModal" />
    <ForgotPasswordModal ref="forgotPasswordModal" />
    <!-- </perfect-scrollbar> -->
  </div>
</template>
<script>
import axios from "axios";
import vueHeadful from "vue-headful";
import { mapState, mapMutations } from "vuex";
import { Button } from "@/components";
import ForgotPasswordModal from "@/pages/components/ForgotPasswordModal.vue";
import LoginModal from "@/pages/components/LoginModal.vue";

const defaultTxt = "Airport Parking Club";

export default {
  components: {
    vueHeadful,
    [Button.name]: Button,
    ForgotPasswordModal,
    LoginModal,
  },
  data() {
    return {
      loader: null,
      showReserve: false,
      directReserveList: [
        "/history",
        "/settings",
        "/faq",
        "/privacy-policy",
        "/terms-of-service",
      ],
    };
  },
  computed: {
    ...mapState(["loading", "options"]),
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        // this.$refs.pScroll.$el.scrollTop = 0;
        this.setLoading(true);
      }

      if (this.directReserveList.includes(to.name)) {
        this.showReserve = true;
      } else {
        this.showReserve = false;
      }
    },
    loading() {
      if (this.loading) {
        this.loader = this.$loading.show();
      } else {
        if (this.loader) {
          this.loader.hide();
        }
      }
    },
  },
  created() {
    this.setLoading(true);
    this.getPageOptions();
    if (this.directReserveList.includes(this.$route.name)) {
      this.showReserve = true;
    }
  },
  methods: {
    ...mapMutations(["setLoading", "setOptions"]),
    getPageOptions() {
      axios
        .get(`airport/pageinfo?domain=${window.location.href}`)
        .then((res) => {
          const { data } = res;
          console.log("airport/pageinfo: ", data);
          this.setOptions(data);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.ps {
  height: 100vh;
}
.page {
  min-height: 100vh;
  padding-top: 76px;
}
.btn-reserve {
  position: fixed;
  bottom: 32px;
  right: 16px;
}
</style>
